module.exports = __webpack_public_path__ + "img/greenModal.5e42e783.svg";